import { apiClient } from '../apiClient';
import { SchoolsResponse, SchoolsQueryParams } from '../../types/school';

interface SchoolsListResponse {
    status: string;
    message: string;
    data: Array<{
        id: number;
        name: string;
    }>;
}

export const schoolsService = {
    getSchools: async (params?: SchoolsQueryParams): Promise<SchoolsResponse> => {
        const response = await apiClient.get<SchoolsResponse>('/api/v1/admin/schools', {
            params,
        });
        return response.data;
    },

    getSchoolsList: async (): Promise<SchoolsListResponse> => {
        const response = await apiClient.get<SchoolsListResponse>('/api/v1/admin/schools/list');
        return response.data;
    },
}; 